import { LanderV2Marketing } from "../../../Components/LanderV2/LanderV2Marketing";
import { QuotesStep } from "../../../Components/LanderV2/annuitycalculator-v3/QuotesStep";
import { Variant1QuoteBlueLoadingOverlay, Variant1BookingStep, Variant1AdhocBookingStep } from "../../../Components/LanderV2/annuitycalculator-v1/VariantV1";
import { LanderV2CampaignConfig } from "./types";
import { pensionFundQuestion, personalDetailQuestions, sharedSurveyProps, yesNoChoices } from "./shared";

export const annuitycalculatorV3: LanderV2CampaignConfig = {
  slug: "annuitycalculator-ux2-vlm1",
  heading: "How much will your pension pay out?",
  subheading:
    "Find out in minutes with a secure annuity quote journey built around the whole UK open provider market.",
  proofLine: "Compare every major UK annuity provider in one secure flow.",
  accent: "magenta",
  surveyFormId: "annuitycalculator-ux2-vlm1",
  landingPageTheme: "Pense Variant B",
  landingPageVariation: "annuitycalculator-ux2-vlm1",
  landingPageVersion: "ux2-vlm1",
  headlineVariants: [
    {
      keywords: ["annuity calculator", "pension calculator", "retirement estimate"],
      heading: "How much will your pension pay out?",
      subheading: "Find out in 2 minutes with our smart annuity calculator.",
    },
    {
      keywords: ["best annuity rates", "compare annuities", "top pension providers"],
      heading: "Compare the UK's best annuity rates for 2026.",
      subheading: "Find the highest-paying providers in less than 2 minutes.",
    },
    {
      keywords: ["annuity quotes", "pension quotes", "get an annuity quote", "free retirement quote"],
      heading: "Ready to see what your pension will pay out?",
      subheading: "Get your personalised quotes in as little as 2 minutes.",
    },
  ],
  initialData: {},
  surveyProps: sharedSurveyProps,
  MarketingComponent: LanderV2Marketing,
  steps: [
    {
      slug: "quote-entry",
      isEntry: true,
      completeText: "GET QUOTES",
      schemaPage: {
        name: "quoteEntry",
        elements: [
          {
            type: "ageinput",
            name: "dateOfBirth",
            title: "Your Age",
            isRequired: true,
          },
          {
            ...pensionFundQuestion,
            startWithNewLine: false,
          },
        ],
      },
    },
    {
      slug: "quote-details",
      next: "address",
      completeText: "Next",
      schemaPage: {
        name: "quoteDetails",
        title: "First, let's find the right products for you...",
        elements: [
          {
            type: "retirementdate",
            name: "annuity.plannedRetirementDate",
            title: "Date you're planning to retire",
            isRequired: true,
          },
          {
            type: "radiogroup",
            name: "medicalInformation.previousOrCurrentSmokerYesNo",
            title: "Are you a smoker?",
            isRequired: true,
            elementCssClass: "radio-group-as-button",
            colCount: 2,
            choices: yesNoChoices,
          },
          {
            type: "radiogroup",
            name: "maritalStatus",
            title: "Are you married?",
            isRequired: true,
            elementCssClass: "radio-group-as-button",
            colCount: 2,
            startWithNewLine: false,
            choices: yesNoChoices,
          },
          {
            type: "radiogroup",
            name: "annuity.taxFreeCashTypeID",
            title: "Have you already taken any tax free cash from your pension?",
            isRequired: true,
            elementCssClass: "radio-group-as-button",
            colCount: 2,
            choices: [
              { value: 5907, text: "No" },
              { value: 5904, text: "Yes" },
            ],
          },
        ],
      },
      layoutClassName: "lv2-survey-2col",
    },
    {
      slug: "address",
      previous: "quote-details",
      next: "personal-details",
      completeText: "Next",
      schemaPage: {
        name: "address",
        title: "Great, now we need to check your location",
        description: "Just to confirm you're eligible as a UK resident",
        elements: [
          {
            type: "addressautocomplete",
            name: "address",
            title: "Start entering your address",
            placeholder: "Start entering your address",
            isRequired: true,
          },
          { type: "text", name: "postcode", title: "Postcode", visible: false },
          { type: "text", name: "city", title: "City", visible: false },
          { type: "text", name: "region", title: "Region", visible: false },
          { type: "text", name: "country", title: "Country", visible: false },
        ],
      },
    },
    {
      slug: "personal-details",
      previous: "address",
      next: "quotes",
      completeText: "Get quotes",
      fetchesQuotes: true,
      LoadingComponent: Variant1QuoteBlueLoadingOverlay,
      schemaPage: {
        name: "personalDetails",
        title: "Good news! We have some great quotes waiting!",
        description: "For security, we just need a little more information about you.",
        elements: personalDetailQuestions.filter((question) => !["address", "postcode", "city", "region", "country"].includes(question.name)),
      },
      layoutClassName: "ux2-personal-details-survey",
      illustrationSrc: "/media/illustrations/BW/PNG/like.png",
      illustrationAlt: "",
    },
    {
      slug: "quotes",
      Component: QuotesStep,
      previous: "personal-details",
      completeText: "Finish",
      schemaPage: {
        name: "quotes",
        title: "Your quotes are ready",
        elements: [],
      },
    },
    {
      slug: "booking",
      Component: Variant1BookingStep,
      previous: "quotes",
      completeText: "Book",
      startOverOnNav: false,
      schemaPage: {
        name: "booking",
        title: "Book an appointment",
        elements: [],
      },
    },
    {
      slug: "book-appointment",
      Component: Variant1AdhocBookingStep,
      offFunnel: true,
      completeText: "Book",
      startOverOnNav: false,
      schemaPage: {
        name: "adhocBooking",
        title: "Book an appointment",
        elements: [],
      },
    },
  ],
};
